import { getRoot } from "mobx-state-tree"


export const getUserSessionToken = self => {
  const rootStore = getRoot(self)
  return rootStore.auth.user.sessionToken
}
